





















import Vue from "vue";

export default Vue.extend({
    props: {
        installationName: String,
        machineSerialNumber: String,
        showDialog: Boolean,
    },
    data() {
        return {
            onlyNumber: [(v) => /^\d+$/.test(v) || this.$t("smartLock.onlyNumber"), (v) => /^\d{8}$/.test(v) || this.$t("smartLock.8digit")],
            closingCode: null,
        };
    },
    computed: {
        canSave() {
            if (this.closingCode && /^\d{8}$/.test(this.closingCode)) return true;
            return false;
        },
        showInsertClosingCodeDialog: {
            get() {
                return this.showDialog;
            },
            set(newValue: boolean) {
                this.$emit("update:showDialog", newValue);
            },
        },
    },
    watch: {
        machineSerialNumber() {
            this.$refs.insertClosingCodeForm.reset();
        },
    },
    methods: {
        insertClosingCode() {
            this.$emit("inserted", this.closingCode);
            this.showInsertClosingCodeDialog = false;
            this.$refs.insertClosingCodeForm.reset();
        },
        cancelPressed() {
            this.showInsertClosingCodeDialog = false;
            this.$refs.insertClosingCodeForm.reset();
        },
    },
});
